import moment from "moment";
import { toast } from "react-toastify";

export const validateMultipleEmailsCommaSeparated = (emails) => {
    let res = emails.split(",");

    if (res.length > 100) {
        toast.error("You can add upto 100 recipients only");
        return false;
    }
    for (let i = 0; i < res.length; i++) {
        if (validateEmail(res[i].trim()) == false) {
            toast.error("Please check, `" + res[i] + "` Is not valid email");
            return false;
        }
    }
    return true;
};

function validateEmail(sEmail) {
    let filter = /^([\w-.]+)@((\[[a-zA-Z0-9]{1,3}\.[a-zA-Z0-9]{1,3}\.[a-zA-Z0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{3,9}|[a-zA-Z0-9]{1,3})(\]?)$/;
    if (filter.test(sEmail)) {
        return true;
    } else {
        return false;
    }
}

export const fieldValueCheck = (value) => {
    // returns true if the field is filled
    switch (typeof value) {
        case "object":
            if (Object.keys(value).length === 0) return true;
            else return false;
        case "string":
            if (value.trim().length === 0) return true;
            else return false;
        default:
            return false;
    }
};

export const getTopicsParamsList = (topics) => {
    let params = [];

    topics.forEach((t) => {
        if (t.label === "All" && t.value === "all") return;
        params.push({
            id: t.topic_id,
            name: t.topic_name,
            boolean: [
                {
                    id: t.value,
                    name: t.label,
                },
            ],
        });
    });

    return params;
};

export const getPlatformsParams = (platforms) => {
    let params = [];

    platforms.forEach((p) => {
        if (p.label === "All" && p.value === "all") return;
        params.push({
            id: p.value,
            name: p.label,
        });
    });

    return params;
};

export const getPublicationsParamsList = (publications) => {
    let params = [];

    publications.forEach((p) => {
        if (p.label === "All" && p.value === "all") return;
        params.push({
            id: p.value,
            name: p.label,
        });
    });

    return params;
};

export const getLanguagesParams = (languages) => {
    let params = [];

    languages.forEach((l) => {
        if (l.label === "All" && l.value === "all") return;
        params.push({
            id: l.value,
            name: l.label,
        });
    });

    return params;
};

export const getLocationsParams = (locations) => {
    let params = [];

    locations.forEach((l) => {
        if (l.label === "All" && l.value === "all") return;
        params.push({
            id: l.value,
            name: l.label,
        });
    });

    return params;
};
export const trialPeriodCheck = (system_packagesArr, company_created_date, user_timezone_name) => {
    // let tz = JSON.parse(localStorage.company).user_timezone_name;
    const { trial_period } = system_packagesArr.find((r) => r.name === "Free");
    const dateWithTrialPeriodAdded = moment(company_created_date).add(trial_period, "days").add(1, "day");
    const currentDate = moment(new Date()).tz(user_timezone_name);
    const daysLeft = dateWithTrialPeriodAdded.diff(currentDate, "day");
    return daysLeft;
};
